import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTikTok = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M10.422.997a.7.7 0 0 0-.701-.701c-.395.008-.701.319-.701.701v10.316c0 1.617-1.383 2.984-3.16 2.984s-3.16-1.366-3.16-2.984S4.084 8.33 5.861 8.33a.7.7 0 1 0 0-1.401c-2.488 0-4.561 1.933-4.561 4.385s2.073 4.385 4.561 4.385 4.561-1.933 4.561-4.385V3.97c.137.12.281.233.431.338 1.051.736 2.418 1.124 3.758 1.124a.7.7 0 1 0 0-1.401c-1.09 0-2.168-.319-2.955-.87-.775-.543-1.233-1.278-1.235-2.157",
		fill: "#333"
	})
});
export default SvgTikTok;
